export const OPEN_WHS_DISCREPANCIES_MODAL = 'OPEN_WHS_DISCREPANCIES_MODAL';
export const CLOSE_WHS_DISCREPANCIES_MODAL = 'CLOSE_WHS_DISCREPANCIES_MODAL';

function openWhsDiscrepanciesModal() {
  return {
    type: OPEN_WHS_DISCREPANCIES_MODAL,
    isWhsDiscrepanciesModalShown: true
  };
}

function closeWhsDiscrepanciesModal() {
  return {
    type: CLOSE_WHS_DISCREPANCIES_MODAL,
    isWhsDiscrepanciesModalShown: false
  };
}

export function showWhsDiscrepanciesModal() {
  return (dispatch) => {
    dispatch(openWhsDiscrepanciesModal());
  };
}

export function hideWhsDiscrepanciesModal() {
  return (dispatch) => {
    dispatch(closeWhsDiscrepanciesModal());
  };
}
